export interface StrapiItem {
  id: number;
  documentId?: string;
  [key: string]: any;
}

export interface StrapiState {
  [modelName: string]: {
    data?: any[];
    loading?: boolean;
    error?: string | null;
    pagination?: {
      page: number;
      pageSize: number;
      pageCount: number;
      total: number;
    };
  };
}

export enum StrapiActionTypes {
  FETCH_REQUEST_MYTASKS = 'strapi/FETCH_REQUEST_MYTASKS',
  FETCH_SUCCESS_MYTASKS = 'strapi/FETCH_SUCCESS_MYTASKS',
  FETCH_FAILURE_MYTASKS = 'strapi/FETCH_FAILURE_MYTASKS',

  ADD_REQUEST_MYTASKS = 'strapi/ADD_REQUEST_MYTASKS',
  ADD_SUCCESS_MYTASKS = 'strapi/ADD_SUCCESS_MYTASKS',
  ADD_FAILURE_MYTASKS = 'strapi/ADD_FAILURE_MYTASKS',

  UPDATE_REQUEST_MYTASKS = 'strapi/UPDATE_REQUEST_MYTASKS',
  UPDATE_SUCCESS_MYTASKS = 'strapi/UPDATE_SUCCESS_MYTASKS',
  UPDATE_FAILURE_MYTASKS = 'strapi/UPDATE_FAILURE_MYTASKS',

  DELETE_REQUEST_MYTASKS = 'strapi/DELETE_REQUEST_MYTASKS',
  DELETE_SUCCESS_MYTASKS = 'strapi/DELETE_SUCCESS_MYTASKS',
  DELETE_FAILURE_MYTASKS = 'strapi/DELETE_FAILURE_MYTASKS',
}

export interface FetchRequestAction {
  type: StrapiActionTypes.FETCH_REQUEST_MYTASKS;
  payload: {
    modelName: string;
    params?: any;
    pagination?: {
      page: number;
      pageSize: number;
    };
  };
}

export interface FetchSuccessAction {
  type: StrapiActionTypes.FETCH_SUCCESS_MYTASKS;
  payload: {
    modelName: string;
    data: StrapiItem[];
    pagination?: {
      page: number;
      pageSize: number;
      pageCount: number;
      total: number;
    };
  };
}

export interface FetchFailureAction {
  type: StrapiActionTypes.FETCH_FAILURE_MYTASKS;
  payload: {
    modelName: string;
    error: string;
  };
}

export interface AddRequestAction {
  type: StrapiActionTypes.ADD_REQUEST_MYTASKS;
  payload: {
    modelName: string;
    data: any;
  };
}

export interface AddSuccessAction {
  type: StrapiActionTypes.ADD_SUCCESS_MYTASKS;
  payload: {
    modelName: string;
    data: StrapiItem;
  };
}

export interface AddFailureAction {
  type: StrapiActionTypes.ADD_FAILURE_MYTASKS;
  payload: {
    modelName: string;
    error: string;
  };
}

export interface UpdateRequestAction {
  type: StrapiActionTypes.UPDATE_REQUEST_MYTASKS;
  payload: {
    modelName: string;
    documentId: string;
    data: any;
  };
}

export interface UpdateSuccessAction {
  type: StrapiActionTypes.UPDATE_SUCCESS_MYTASKS;
  payload: {
    modelName: string;
    data: StrapiItem;
  };
}

export interface UpdateFailureAction {
  type: StrapiActionTypes.UPDATE_FAILURE_MYTASKS;
  payload: {
    modelName: string;
    error: string;
  };
}

export interface DeleteRequestAction {
  type: StrapiActionTypes.DELETE_REQUEST_MYTASKS;
  payload: {
    modelName: string;
    documentId: string;
  };
}

export interface DeleteSuccessAction {
  type: StrapiActionTypes.DELETE_SUCCESS_MYTASKS;
  payload: {
    modelName: string;
    documentId: string;
  };
}

export interface DeleteFailureAction {
  type: StrapiActionTypes.DELETE_FAILURE_MYTASKS;
  payload: {
    modelName: string;
    error: string;
  };
}

export type StrapiActions =
  | FetchRequestAction
  | FetchSuccessAction
  | FetchFailureAction
  | AddRequestAction
  | AddSuccessAction
  | AddFailureAction
  | UpdateRequestAction
  | UpdateSuccessAction
  | UpdateFailureAction
  | DeleteRequestAction
  | DeleteSuccessAction
  | DeleteFailureAction;
